export const defaultImage = '/region_header.jpg';
